import React from "react";
import { PtUser } from "oneclick-component/src/store/apis/enhancedApi";

interface AuthContextValue {
  login: () => void;
  logout: () => void;
  fetchUser: () => Promise<PtUser | undefined>;
}

export const AuthContext = React.createContext<AuthContextValue>(null as any);
